import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Layout from './components/Layout'
import ConversationWrapper from './components/ConversationWrapper'
import Tasks from '../Tasks'
import PromptPage from '../Tasks/PromptPage'
import Search from '../Search'
import './styles/main.css'
import './styles/newUI.css'

const Chat = () => {
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route index element={<ConversationWrapper />} />
                <Route path='tasks' element={<Tasks />} />
                <Route path='tasks/new' element={<PromptPage />} />
                <Route path='tasks/:id/edit' element={<PromptPage />} />
                <Route path='search' element={<Search />} />
                <Route path=':id' element={<ConversationWrapper />} />
            </Route>
        </Routes>
    )
}

export default Chat
